import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_667e1cac from 'nuxt_plugin_plugin_667e1cac' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_axios_c17236d0 from 'nuxt_plugin_axios_c17236d0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginscraft4a440668_eb8511dc from 'nuxt_plugin_pluginscraft4a440668_eb8511dc' // Source: ./plugins.craft.4a440668.coffee (mode: 'all')
import nuxt_plugin_nuxtplugin43164e1c_668f2bc9 from 'nuxt_plugin_nuxtplugin43164e1c_668f2bc9' // Source: ./nuxt.plugin.43164e1c.js (mode: 'client')
import nuxt_plugin_nuxtplugine7f211b8_555c9ec8 from 'nuxt_plugin_nuxtplugine7f211b8_555c9ec8' // Source: ./nuxt.plugin.e7f211b8.js (mode: 'client')
import nuxt_plugin_nuxtplugin05378361_0a6fa6d1 from 'nuxt_plugin_nuxtplugin05378361_0a6fa6d1' // Source: ./nuxt.plugin.05378361.js (mode: 'all')
import nuxt_plugin_objectFitPolyfill_3e7d4bba from 'nuxt_plugin_objectFitPolyfill_3e7d4bba' // Source: ./nuxt-polyfill/objectFitPolyfill.js (mode: 'all')
import nuxt_plugin_nuxtplugin7b928df8_53d99924 from 'nuxt_plugin_nuxtplugin7b928df8_53d99924' // Source: ./nuxt.plugin.7b928df8.js (mode: 'client')
import nuxt_plugin_gtm_8f301d24 from 'nuxt_plugin_gtm_8f301d24' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_workbox_6af093b4 from 'nuxt_plugin_workbox_6af093b4' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_6fb63272 from 'nuxt_plugin_metaplugin_6fb63272' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_6666e78a from 'nuxt_plugin_iconplugin_6666e78a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_3192e748 from 'nuxt_plugin_sentryserver_3192e748' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_fd05ca58 from 'nuxt_plugin_sentryclient_fd05ca58' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_globals_2ad0cf0b from 'nuxt_plugin_globals_2ad0cf0b' // Source: ../../../plugins/globals (mode: 'all')
import nuxt_plugin_helpers_53a14460 from 'nuxt_plugin_helpers_53a14460' // Source: ../../../plugins/helpers (mode: 'all')
import nuxt_plugin_grassdoor_62856d7f from 'nuxt_plugin_grassdoor_62856d7f' // Source: ../../../plugins/grassdoor (mode: 'all')
import nuxt_plugin_measureviewport_446208ba from 'nuxt_plugin_measureviewport_446208ba' // Source: ../../../plugins/measure-viewport (mode: 'client')
import nuxt_plugin_flickity_85852b70 from 'nuxt_plugin_flickity_85852b70' // Source: ../../../plugins/flickity (mode: 'client')
import nuxt_plugin_localstorage_abea9098 from 'nuxt_plugin_localstorage_abea9098' // Source: ../../../plugins/local-storage (mode: 'client')
import nuxt_plugin_checkbuysupport_329ca344 from 'nuxt_plugin_checkbuysupport_329ca344' // Source: ../../../plugins/check-buy-support (mode: 'client')
import nuxt_plugin_agegate_b8ebcb44 from 'nuxt_plugin_agegate_b8ebcb44' // Source: ../../../plugins/age-gate (mode: 'client')
import nuxt_plugin_newslettermodal_811225c4 from 'nuxt_plugin_newslettermodal_811225c4' // Source: ../../../plugins/newsletter-modal (mode: 'client')
import nuxt_plugin_detectzip_4067793c from 'nuxt_plugin_detectzip_4067793c' // Source: ../../../plugins/detect-zip (mode: 'client')
import nuxt_plugin_canonicalupdate_6924b338 from 'nuxt_plugin_canonicalupdate_6924b338' // Source: ../../../plugins/canonical-update (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":function (title) {
        if (title && title !== 'Kiva Confections') {
          return `${title} | Kiva Confections`;
        } else {
          return 'Kiva Confections';
        }
      },"meta":[{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"msapplication-tap-highlight","content":"no"},{"name":"facebook-domain-verification","content":"ls6mixgaaldpw8q4k012llxoetpq4z"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Ffcv5hlv.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcloud.typography.com\u002F6597038\u002F7700012\u002Fcss\u002Ffonts.css"},{"rel":"canonical","href":""}],"script":[{"hid":"modernizr","innerHTML":"\u002F*! modernizr 3.6.0 (Custom Build) | MIT *\n * https:\u002F\u002Fmodernizr.com\u002Fdownload\u002F?-touchevents-addtest-setclasses !*\u002F\n!function (e, n, t) { function o(e, n) { return typeof e === n } function s() { var e, n, t, s, i, a, r; for (var l in c) if (c.hasOwnProperty(l)) { if (e = [], n = c[l], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (t = 0; t \u003C n.options.aliases.length; t++)e.push(n.options.aliases[t].toLowerCase()); for (s = o(n.fn, \"function\") ? n.fn() : n.fn, i = 0; i \u003C e.length; i++)a = e[i], r = a.split(\".\"), 1 === r.length ? Modernizr[r[0]] = s : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = s), u.push((s ? \"\" : \"no-\") + r.join(\"-\")) } } function i(e) { var n = p.className, t = Modernizr._config.classPrefix || \"\"; if (h && (n = n.baseVal), Modernizr._config.enableJSClass) { var o = new RegExp(\"(^|\\\\s)\" + t + \"no-js(\\\\s|$)\"); n = n.replace(o, \"$1\" + t + \"js$2\") } Modernizr._config.enableClasses && (n += \" \" + t + e.join(\" \" + t), h ? p.className.baseVal = n : p.className = n) } function a() { return \"function\" != typeof n.createElement ? n.createElement(arguments[0]) : h ? n.createElementNS.call(n, \"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\", arguments[0]) : n.createElement.apply(n, arguments) } function r() { var e = n.body; return e || (e = a(h ? \"svg\" : \"body\"), e.fake = !0), e } function l(e, t, o, s) { var i, l, f, u, c = \"modernizr\", d = a(\"div\"), h = r(); if (parseInt(o, 10)) for (; o--;)f = a(\"div\"), f.id = s ? s[o] : c + (o + 1), d.appendChild(f); return i = a(\"style\"), i.type = \"text\u002Fcss\", i.id = \"s\" + c, (h.fake ? h : d).appendChild(i), h.appendChild(d), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(n.createTextNode(e)), d.id = c, h.fake && (h.style.background = \"\", h.style.overflow = \"hidden\", u = p.style.overflow, p.style.overflow = \"hidden\", p.appendChild(h)), l = t(d, e), h.fake ? (h.parentNode.removeChild(h), p.style.overflow = u, p.offsetHeight) : d.parentNode.removeChild(d), !!l } function f(e, n) { if (\"object\" == typeof e) for (var t in e) g(e, t) && f(t, e[t]); else { e = e.toLowerCase(); var o = e.split(\".\"), s = Modernizr[o[0]]; if (2 == o.length && (s = s[o[1]]), \"undefined\" != typeof s) return Modernizr; n = \"function\" == typeof n ? n() : n, 1 == o.length ? Modernizr[o[0]] = n : (!Modernizr[o[0]] || Modernizr[o[0]] instanceof Boolean || (Modernizr[o[0]] = new Boolean(Modernizr[o[0]])), Modernizr[o[0]][o[1]] = n), i([(n && 0 != n ? \"\" : \"no-\") + o.join(\"-\")]), Modernizr._trigger(e, n) } return Modernizr } var u = [], c = [], d = { _version: \"3.6.0\", _config: { classPrefix: \"\", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (e, n) { var t = this; setTimeout(function () { n(t[e]) }, 0) }, addTest: function (e, n, t) { c.push({ name: e, fn: n, options: t }) }, addAsyncTest: function (e) { c.push({ name: null, fn: e }) } }, Modernizr = function () { }; Modernizr.prototype = d, Modernizr = new Modernizr; var p = n.documentElement, h = \"svg\" === p.nodeName.toLowerCase(), v = d._config.usePrefixes ? \" -webkit- -moz- -o- -ms- \".split(\" \") : [\"\", \"\"]; d._prefixes = v; var m = d.testStyles = l; Modernizr.addTest(\"touchevents\", function () { var t; if (\"ontouchstart\" in e || e.DocumentTouch && n instanceof DocumentTouch) t = !0; else { var o = [\"@media (\", v.join(\"touch-enabled),(\"), \"heartz\", \")\", \"{#modernizr{top:9px;position:absolute}}\"].join(\"\"); m(o, function (e) { t = 9 === e.offsetTop }) } return t }); var g; !function () { var e = {}.hasOwnProperty; g = o(e, \"undefined\") || o(e.call, \"undefined\") ? function (e, n) { return n in e && o(e.constructor.prototype[n], \"undefined\") } : function (n, t) { return e.call(n, t) } }(), d._l = {}, d.on = function (e, n) { this._l[e] || (this._l[e] = []), this._l[e].push(n), Modernizr.hasOwnProperty(e) && setTimeout(function () { Modernizr._trigger(e, Modernizr[e]) }, 0) }, d._trigger = function (e, n) { if (this._l[e]) { var t = this._l[e]; setTimeout(function () { var e, o; for (e = 0; e \u003C t.length; e++)(o = t[e])(n) }, 0), delete this._l[e] } }, Modernizr._q.push(function () { d.addTest = f }), s(), i(u), delete d.addTest, delete d.addAsyncTest; for (var y = 0; y \u003C Modernizr._q.length; y++)Modernizr._q[y](); e.Modernizr = Modernizr }(window, document);\nModernizr.addTest('ie', !!navigator.userAgent.match(\u002FMSIE|Trident\u002Fi)); \u002F\u002F Test for IE"},{"hid":"polyfill","crossorigin":"anonymous","src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.min.js?features=IntersectionObserver%2CNodeList.prototype.forEach%2Cdefault%2C2017%2C2016%2C2015%2CURL%2CString.prototype.padStart%2CElement.prototype.prepend%2CElement.prototype.remove%2CElement.prototype.append%2CArray.prototype.values%2CObject.values%2CObject.assign%2CCustomEvent%2CArray.prototype.findIndex"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T26CRPR')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"modernizr":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T26CRPR&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_667e1cac === 'function') {
    await nuxt_plugin_plugin_667e1cac(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_c17236d0 === 'function') {
    await nuxt_plugin_axios_c17236d0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginscraft4a440668_eb8511dc === 'function') {
    await nuxt_plugin_pluginscraft4a440668_eb8511dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugin43164e1c_668f2bc9 === 'function') {
    await nuxt_plugin_nuxtplugin43164e1c_668f2bc9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugine7f211b8_555c9ec8 === 'function') {
    await nuxt_plugin_nuxtplugine7f211b8_555c9ec8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin05378361_0a6fa6d1 === 'function') {
    await nuxt_plugin_nuxtplugin05378361_0a6fa6d1(app.context, inject)
  }

  if (typeof nuxt_plugin_objectFitPolyfill_3e7d4bba === 'function') {
    await nuxt_plugin_objectFitPolyfill_3e7d4bba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtplugin7b928df8_53d99924 === 'function') {
    await nuxt_plugin_nuxtplugin7b928df8_53d99924(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_8f301d24 === 'function') {
    await nuxt_plugin_gtm_8f301d24(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_6af093b4 === 'function') {
    await nuxt_plugin_workbox_6af093b4(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_6fb63272 === 'function') {
    await nuxt_plugin_metaplugin_6fb63272(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_6666e78a === 'function') {
    await nuxt_plugin_iconplugin_6666e78a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_3192e748 === 'function') {
    await nuxt_plugin_sentryserver_3192e748(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_fd05ca58 === 'function') {
    await nuxt_plugin_sentryclient_fd05ca58(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_2ad0cf0b === 'function') {
    await nuxt_plugin_globals_2ad0cf0b(app.context, inject)
  }

  if (typeof nuxt_plugin_helpers_53a14460 === 'function') {
    await nuxt_plugin_helpers_53a14460(app.context, inject)
  }

  if (typeof nuxt_plugin_grassdoor_62856d7f === 'function') {
    await nuxt_plugin_grassdoor_62856d7f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_measureviewport_446208ba === 'function') {
    await nuxt_plugin_measureviewport_446208ba(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flickity_85852b70 === 'function') {
    await nuxt_plugin_flickity_85852b70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localstorage_abea9098 === 'function') {
    await nuxt_plugin_localstorage_abea9098(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkbuysupport_329ca344 === 'function') {
    await nuxt_plugin_checkbuysupport_329ca344(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_agegate_b8ebcb44 === 'function') {
    await nuxt_plugin_agegate_b8ebcb44(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_newslettermodal_811225c4 === 'function') {
    await nuxt_plugin_newslettermodal_811225c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_detectzip_4067793c === 'function') {
    await nuxt_plugin_detectzip_4067793c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_canonicalupdate_6924b338 === 'function') {
    await nuxt_plugin_canonicalupdate_6924b338(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
